import { registerPlugin } from '@capacitor/core';
var AppTrackingTransparency = registerPlugin('AppTrackingTransparency', {
  web: function web() {
    return import('./web').then(function (m) {
      return new m.AppTrackingTransparencyWeb();
    });
  }
});
export * from './definitions';
export { AppTrackingTransparency };